import { Link } from "react-router-dom";
import { X, Zap } from "lucide-react";

export default function PaywallModal({ open, onClose, message }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] bg-black/70 backdrop-blur-sm flex items-center justify-center p-6" onClick={onClose}>
      <div className="bg-[#0e0e0f] border border-[#FF3B30]/40 w-full max-w-md p-8" onClick={(e) => e.stopPropagation()} data-testid="paywall-modal">
        <div className="flex items-start justify-between mb-6">
          <div>
            <div className="sd-label text-[#FF3B30] mb-2">● UPGRADE REQUIRED</div>
            <h3 className="font-display text-3xl leading-tight">Time to level up.</h3>
          </div>
          <button onClick={onClose} className="text-zinc-500 hover:text-white" data-testid="paywall-close-btn">
            <X size={18} strokeWidth={1.5} />
          </button>
        </div>
        <p className="text-sm text-zinc-300 leading-relaxed">{message}</p>
        <div className="mt-6 grid gap-2">
          <Link to="/pricing" onClick={onClose} className="sd-btn sd-btn-accent h-11" data-testid="paywall-upgrade-btn">
            <Zap size={14} strokeWidth={1.5} /> See plans
          </Link>
          <button onClick={onClose} className="sd-btn sd-btn-ghost h-11" data-testid="paywall-later-btn">
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
}
